import FetchUtils, { parseJSON } from './fetch_utils';
import { getBackendUri } from '../utils/EnvConfigUtils';
import { nullSafeGet } from '../utils/DataAccessUtils';

const fetchUtils = new FetchUtils();
const baseUrl = getBackendUri();

export interface G2ReviewTokenResponse {
	state?: string;
	reviewExists?: boolean;
}

export const fetchG2ReviewToken =
	(userType: string, email: string) =>
	(dispatch: any): Promise<G2ReviewTokenResponse> => {
		return fetchUtils
			.post(baseUrl + `/api/v1/${userType}/g2/review_token`, {
				data: { email },
			})
			.then(parseJSON)
			.then((response) => {
				// Backend wraps the payload in an OkResponse envelope:
				// { status: 'ok', type: 'G2ReviewToken', data: { state, reviewExists } }
				const tokenResponse = nullSafeGet('json.data', response);
				if (response.ok && tokenResponse) {
					return tokenResponse;
				}
				throw new Error('Failed to fetch G2 review token');
			});
	};
